<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="area-selection-container">
      <Dropdown
        placement="bottom-start"
        v-if="visible"
      >
        <div class="selected-area">
          <slot
            name="placeholder"
            v-bind:currentArea="currentArea"
          >
            <Icon type="ios-pin" />
            <span>{{ currentArea.province }}</span>
            <span>{{ currentArea.city }}</span>
          </slot>
        </div>
        <DropdownMenu
          slot="list"
          class="drop-down-menu"
        >
          <Tabs v-model="activeTab">
            <TabPane
              :label="tempArea.province"
              name="tab1"
            >
              <Row
                type="flex"
                justify="start"
              >
                <Col
                  v-for="(item, index) in provinceArr"
                  :key="index"
                  class="area-item"
                ><span @click="provinceClick(item)">{{ item.name }}</span></Col>
              </Row>
            </TabPane>
            <TabPane
              :label="tempArea.city"
              name="tab2"
            >
              <Row
                type="flex"
                justify="start"
              >
                <Col
                  v-for="(item, index) in cityArr"
                  :key="index"
                  class="area-item"
                ><span @click="cityClick(item)">{{ item.name }}</span></Col>
              </Row>
            </TabPane>
          </Tabs>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import '@/styles/components/location/areaSelection.scss';
import {LocalStorage, StorageName} from '../../utils/storage';
const prefix = 'cpt-area-selection';
export default {
  name: 'AreaSelection',
  inject: { reloadPage: 'reloadPage' },
  props: {
    province: {
      type: Object
    },
    city: {
      type: Object
    }
  },
  data () {
    return {
      prefix,
      visible: true,
      tempArea: {
        province: '请选择',
        city: '请选择'
      },
      currentArea: {
        province: '请选择',
        city: '请选择'
      },
      proviceInfo: {
        id: 0,
        name: ''
      },
      cityInfo: {
        id: 0,
        name: ''
      },
      activeTab: 'tab1',
      provinceArr: [],
      cityArr: [],
      warehouse: ''
    };
  },
  methods: {
    ...mapActions({
      getCitiesByStateId: 'getCitiesByStateId',
      getStatesByCountryId: 'getStatesByCountryId',
      getNearestWarehouseByCityId: 'getNearestWarehouseByCityId'
    }),
    provinceClick (val) {
      this.tempArea = {
        province: val.name,
        city: '请选择'
      };
      this.proviceInfo = {
        id: val.id,
        name: val.name
      };
      this.activeTab = 'tab2';
      this.getCitiesByStateId(val.id).then(res => {
        this.cityArr = res.Data.List;
      });
    },
    cityClick (val) {
      this.tempArea.city = val.name;
      // this.activeTab = 'tab1';
      this.currentArea = this.tempArea;
      this.cityInfo = {
        id: val.id,
        name: val.name
      };
      this.getNearestWarehouseByCityId(val.id).then(res => {
        if (res.Success) {
          this.warehouse = res.Data.Name;
          LocalStorage.setItem({name: StorageName.areaInfo.areaInfo, value: {province: this.proviceInfo, city: this.cityInfo, warehouse: this.warehouse}});
        }
      });
      this.reloadPage();
    }
  },
  watch: {
  },
  created () {
    this.currentArea.province = this.province.name;
    this.currentArea.city = this.city.name;
    this.tempArea.province = this.province.name;
    this.tempArea.city = this.city.name;
    this.getStatesByCountryId('172').then(res => {
      this.provinceArr = res.Data.List;
    });
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/location/AreaSelection.vue